// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const iron_leaves: PokeData = {
  "id": 1010,
  "name": "iron-leaves",
  "height": 15,
  "weight": 1250,
  "base_experience": 295,
  "types": [
    PokeType.GRASS,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "swords-dance",
    "leer",
    "quick-attack",
    "megahorn",
    "helping-hand",
    "imprison",
    "magical-leaf",
    "leaf-blade",
    "close-combat",
    "night-slash",
    "quick-guard",
    "ally-switch",
    "retaliate",
    "work-up",
    "sacred-sword",
    "solar-blade",
    "psyblade"
  ],
  "moves": [
    "leer",
    "quick-attack",
    "close-combat",
    "night-slash",
    "aromatherapy",
    "psy-pulse",
    "zen-headbutt",
    "energy-ball",
    "overgrowth",
    "frenzy-plant",
    "psywave",
    "prismatic-cage",
    "calm-mind"
  ],
  "evolution_chain": {
    "id": 538,
    "item": null,
    "species": [
      {
        "name": "iron-leaves",
        "order": 1012,
        "types": [
          PokeType.GRASS,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 115,
    "speed": 127,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 5,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
